export const type = 'alert.longMessage';
